import { createSelector } from 'reselect';
import _ from 'lodash';

import { baseCollection } from '../../common/collections';

const _scopedState = state => _.get(state, 'entities.domain', {});

const _domainsById = state => {
  return _scopedState(state).byId;
};

const isFetching = state => _scopedState(state).isFetching;
const hasFetched = state => _scopedState(state).hasFetched;

const domains = createSelector(_domainsById, domains => {
  return _.values(domains);
});

const domainNameFromId = createSelector([domains, (state, id) => id], (domains, domainId) => {
  const _domain = _.find(domains, { id: domainId });
  return !!_domain ? _domain.name : '';
});

const domainTextValue = createSelector(domains, domains => {
  return baseCollection.mapTo(domains);
});

const hasDomains = createSelector([domains, hasFetched], (domains, hasFetched) => domains.length > 0 && !!hasFetched);

export default {
  domains,
  domainNameFromId,
  domainTextValue,
  isFetching,
  hasFetched,
  hasDomains,
};
